export default __webpack_public_path__ + "static/banner_back-d798200acf6788c9486d2203096e2dde.png";